<template>
  <div class="container">
    <h1>REGISTRIERUNG / APP DOWNLOAD</h1>
    <div>
      <div class="step">
        <div class="step-icon">
          <img :src="iconInfo" alt="">
        </div>
        <div class="step-content">
          <h4>Die Master Mass Digital App steht gewerblichen Handwerkern sowie allen Gewerbetreibenden kostenlos zur Verfügung. Sie benötigen lediglich eine gültige ATU-Nummer und ein Android- Smartphone oder -Tablet.</h4>
        </div>
      </div>
      <div class="step">
        <div class="step-icon">
          <img :src="icon1" alt="">
        </div>
        <div class="step-content">
          <h4>1. Schritt / Registrierung:</h4>
          <p>Bitte geben Sie uns im <a href="/register">Registrierungsformular</a> Ihre Daten bekannt.</p>
        </div>
      </div>
      <div class="step">
        <div class="step-icon">
          <img :src="icon2" alt="">
        </div>
        <div class="step-content">
          <h4>2. Schritt / Retourmail mit Downloadlink:</h4>
          <p>Nach erfolgreicher Überprüfung Ihrer Daten durch unser Team erhalten Sie an die angegebene EMail Adresse einen</p>
        </div>
      </div>
      <div class="step">
        <div class="step-icon">
          <img :src="icon3" alt="">
        </div>
        <div class="step-content">
          <h4>3. <a href="https://play.google.com/store/apps/details?id=master.mass.digital" target="_blank">Schritt / App herunterladen</a></h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import icon1 from "~/assets/images/mmd-icon-1.png";
import icon2 from "~/assets/images/mmd-icon-2.png";
import icon3 from "~/assets/images/mmd-icon-3.png";
import iconInfo from "~/assets/images/mmd-icon-info.png";

export default {
  data() {
    return {
      icon1,
      icon2,
      icon3,
      iconInfo,
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  background-color: #506394 !important;
  color: #fff;

  * {
    color: inherit;
  }
}

.step {
  display: flex;
  margin-bottom: 30px;

  &-icon {
    margin-right: 30px;

    img {
      max-width: 100px;
    }
  }

  &-content {
    h4 {
      font-size: 20px;
      line-height: 1.4;
      font-weight: bold;
    }

    a {
      color: inherit;
    }
  }
}
</style>


// WEBPACK FOOTER //
// resources/nuxt/pages/register/steps.vue